// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> apartment-management-consultants-avenue -> regatta
// Generated: 2026-10-14T20:31:14.920Z
// Counts: 1 design, 38 content, 18 slot group, 1 collection binding, 6 section, 0 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_copyright"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Explore What All <span data-type=\"field-token\" data-field=\"property_name\"></span> Has To Offer</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>1 - 3 Bedroom Apartments for Rent in Northglenn, CO</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/northglenn-co-apartments-with-pool::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover Regatta, Northglenn’s choice for apartments with a pool. Enjoy a modern living experience combined with deluxe amenities at our premier location.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/northglenn-co-apartments-with-pool::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Pool in Northglenn, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-49a5-7587-b84e-e2aedab919be.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-fa1c-74bf-a89d-68fd979db7af.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Pricing & Availability"
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 13,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019f602b-1290-76f5-a82d-714493ae3413.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, yellow accents, a gray armchair, and a desk."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "ctasection.card4_image": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "floor-plans-details-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019f602b-06e2-768f-a864-69ff90ad83de.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen and dining area with white cabinets, stainless steel appliances, and a glass-top dining table."
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/019f602b-08d9-716a-9586-56a9257d98bb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, geometric print bedding, nightstands, and a dresser."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 28,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-6993-76a8-9dca-c1d2a531bdec.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area adjacent to kitchen in apartment"
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 26,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166401/01a034b2-693c-70c9-9db6-64d2edb98aa8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and dining area of an apartment with a TV and dining table."
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": 56,
    "fieldOverrides": null
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": 44,
    "fieldOverrides": null
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": 18,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_72dbdde3-de13-45eb-b75f-dc99459f6c1c",
      "custom_4fed0de3-061d-4973-9caf-44b822d64108",
      "custom_e96268c4-e781-48b4-9740-327783b4df96",
      "custom_a73470a7-416e-47d0-8415-7733f82f9823",
      "custom_72874b1a-79ff-4f08-86b9-ff3c531a1c1e",
      "custom_7cff48a9-8cab-445c-aa18-9485a9c4ef0d",
      "custom_3c8e86ff-95a2-44a3-802f-57deaa0c1c32",
      "custom_aebaa80b-65b0-4a32-9895-34f9c180fdb5",
      "custom_e583aef6-7da9-4438-892c-662fd81f0a18",
      "custom_89761508-38aa-4d3a-9f26-f9b71d30726e",
      "custom_ba18cc2a-302b-4790-b46a-15c735ecc6bd",
      "custom_592afe27-7414-4e7a-8fca-38107daf492c",
      "custom_6fc9199f-f22e-4c75-aacd-ff618ebc7c02",
      "custom_7913253e-88b4-48e5-a896-1106162f4fd9",
      "custom_eaec2751-a239-40c5-a639-7e210df6da71",
      "custom_ff0ed0c4-c2ae-4443-a21b-a420965da43c",
      "custom_1580aec5-19e1-481b-bc71-d998e3d02190",
      "custom_c44e7d5c-b7de-432a-a6e2-adcf40397c3a",
      "custom_0d787145-86e6-455f-9f8a-c6fe4def4694",
      "custom_5aee5a52-eb0d-4343-9d8c-c3827a372fb7",
      "custom_4533b745-0d7c-4d92-a57f-bdfcc1f5dd54",
      "custom_15af1c74-fc90-4989-96d3-2f370c124512",
      "custom_22ff8920-c0c6-4a7e-8fd7-f73f8fb63244",
      "custom_80c29914-4eab-4a8a-8da3-3f74ef072328",
      "custom_4ae2b75a-244c-43a1-b260-be5aa9f231c9",
      "custom_8ace5750-2b62-4b9c-9de4-95f6b8002138",
      "custom_842cf95a-a58e-4d02-a543-c7b33ca5cf3a",
      "custom_eb245efd-b5bd-4610-bd58-7897d62388f1",
      "custom_60e34f67-a3cc-4432-b677-f2f19aa0439e",
      "custom_4253a4a6-b420-4d2e-a844-e4947b0b085e",
      "custom_c84b2e60-fda5-429a-9608-d6afb14c4c50",
      "custom_32a49027-8521-477e-a39f-92b75fde2574",
      "custom_9d0a4fc0-c8f0-42c8-a447-f676291252e0",
      "custom_7cb5cab1-83af-4bf7-9e4d-a94850b70755",
      "custom_c60edbbc-71e0-4ea4-b8af-c68db872b2aa",
      "custom_eff9df38-f165-4d62-a40f-fa036b2aa943",
      "custom_1913c0b9-51ad-439d-b6dd-74bf51303b41",
      "custom_f03001e4-7e36-4a65-87d6-8cfa11ea1091",
      "custom_99ceeb3a-1045-43fb-b409-e461f0e59de2",
      "custom_c1c5104c-eebb-43dc-b4c2-6178fab9be5a",
      "custom_916b64b0-867c-4f58-b49a-af3afde1894d",
      "custom_de754ecc-cf41-40cd-8026-f7c7b4351c74"
    ],
    "orderedIds": [
      "custom_02376718-27e5-49e3-a277-77fe3b3a26ac",
      "custom_35fae773-1fb2-420e-867c-2975e7280bad",
      "custom_d726a3ad-9fc8-4ab5-8bfa-cbca7e1265de",
      "custom_32962665-cbb4-4767-b757-7ed6d643ef51",
      "custom_667de890-bf1c-4c61-a878-51111abf8285",
      "custom_23fff07f-99ae-4c8a-ac65-e4b546103343",
      "custom_8e89a1f3-465f-44d1-b3b5-a121f6e0a84b",
      "custom_06ed3d36-4c0c-49a5-8787-20705bead0da",
      "custom_8f1023e4-1c24-4039-b883-483b0e13636e",
      "custom_7be22462-a0ac-4833-bb83-4dfcbc9318a0",
      "custom_d8dd90c8-1717-424a-af78-197693ff07b6",
      "custom_1913c0b9-51ad-439d-b6dd-74bf51303b41",
      "custom_e583aef6-7da9-4438-892c-662fd81f0a18",
      "custom_ba18cc2a-302b-4790-b46a-15c735ecc6bd",
      "custom_89761508-38aa-4d3a-9f26-f9b71d30726e",
      "custom_592afe27-7414-4e7a-8fca-38107daf492c",
      "custom_eaec2751-a239-40c5-a639-7e210df6da71",
      "custom_ff0ed0c4-c2ae-4443-a21b-a420965da43c",
      "custom_6fc9199f-f22e-4c75-aacd-ff618ebc7c02",
      "custom_7913253e-88b4-48e5-a896-1106162f4fd9",
      "custom_1580aec5-19e1-481b-bc71-d998e3d02190",
      "custom_ecaac22f-0eed-491c-85bd-e2c52514390a",
      "custom_a51c006c-8011-4eae-86ca-f2d4595e73be",
      "custom_8ceb8d07-b9c6-49d7-8705-fdfcd6b1661e",
      "custom_30499dfb-aff0-4bfd-a695-8273898b2029",
      "custom_593957cb-2fdf-4e78-9ddc-21e41777312b",
      "custom_a978c914-1716-44ea-879c-bb3dbf7a1cf2",
      "custom_45cd9ded-24af-4418-8b83-a5f588f057ea",
      "custom_de754ecc-cf41-40cd-8026-f7c7b4351c74",
      "custom_00fb58fd-d5e2-4cc4-825c-333411f362c2",
      "custom_ac94cad0-695c-4e63-9c3b-132030f0972c",
      "custom_257d14eb-65c3-4c07-a8ee-cb6272fe91ba",
      "custom_40c53486-9bad-4293-880a-c453a0dd1e08",
      "custom_c142a458-32ef-4d6b-bc5c-a299d28e4f78",
      "custom_916b64b0-867c-4f58-b49a-af3afde1894d",
      "custom_c1c5104c-eebb-43dc-b4c2-6178fab9be5a",
      "custom_99ceeb3a-1045-43fb-b409-e461f0e59de2",
      "custom_f03001e4-7e36-4a65-87d6-8cfa11ea1091",
      "custom_c44e7d5c-b7de-432a-a6e2-adcf40397c3a",
      "custom_0d787145-86e6-455f-9f8a-c6fe4def4694",
      "custom_5aee5a52-eb0d-4343-9d8c-c3827a372fb7",
      "custom_4533b745-0d7c-4d92-a57f-bdfcc1f5dd54",
      "custom_15af1c74-fc90-4989-96d3-2f370c124512",
      "custom_22ff8920-c0c6-4a7e-8fd7-f73f8fb63244",
      "custom_842cf95a-a58e-4d02-a543-c7b33ca5cf3a",
      "custom_eb245efd-b5bd-4610-bd58-7897d62388f1",
      "custom_fda49c73-b887-4508-8f12-70c54c77d6f3",
      "custom_5d3928f9-d2fe-456f-8c0e-dc28e78ac435",
      "custom_8ace5750-2b62-4b9c-9de4-95f6b8002138",
      "custom_80c29914-4eab-4a8a-8da3-3f74ef072328",
      "custom_4ae2b75a-244c-43a1-b260-be5aa9f231c9",
      "custom_60e34f67-a3cc-4432-b677-f2f19aa0439e",
      "custom_4253a4a6-b420-4d2e-a844-e4947b0b085e",
      "custom_c84b2e60-fda5-429a-9608-d6afb14c4c50",
      "custom_9d0a4fc0-c8f0-42c8-a447-f676291252e0",
      "custom_32a49027-8521-477e-a39f-92b75fde2574",
      "custom_6182fe24-86af-461f-9fae-b7a0fbdd0d41",
      "custom_c60edbbc-71e0-4ea4-b8af-c68db872b2aa",
      "custom_7cb5cab1-83af-4bf7-9e4d-a94850b70755",
      "custom_99cf01ce-b807-41b4-b2e2-2df32c19cb97",
      "custom_9cb4e51a-a41a-4d87-bc2f-cea90d14ad00",
      "custom_30d4ff1c-e977-4b05-b78e-6a2b480d6dcf",
      "custom_7b338c77-2460-4826-a686-548c028d5aa2",
      "custom_eff9df38-f165-4d62-a40f-fa036b2aa943"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
